export function createRange(label, min, max, step, defaultValue, handleChange) {
  return { label, min, max, step, defaultValue, handleChange };
}
